import { render, staticRenderFns } from "./ib-form.vue?vue&type=template&id=a2f43f86&lang=pug&"
import script from "./ib-form.vue?vue&type=script&lang=js&"
export * from "./ib-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f43f86')) {
      api.createRecord('a2f43f86', component.options)
    } else {
      api.reload('a2f43f86', component.options)
    }
    module.hot.accept("./ib-form.vue?vue&type=template&id=a2f43f86&lang=pug&", function () {
      api.rerender('a2f43f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/ib-form.vue"
export default component.exports